import { render } from "./FreeGames.vue?vue&type=template&id=1b1c179e"
import script from "./FreeGames.vue?vue&type=script&lang=js"
export * from "./FreeGames.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__